import { BasicCalendar, type BasicCalendarProps } from '@/components/basicCalendar/BasicCalendar';

import styles from './compactCalendar.module.css';

export const CompactCalendar = (props: BasicCalendarProps) => <BasicCalendar className={styles.compactCalendar} {...props} />;
